/**
 * Dev-only consentable service that exercises the banner, the preferences
 * modal and the accept/reject plumbing without touching any real tracker.
 * Enabled by VITE_CONSENT_DEMO=true (see devenv/docker-compose-dev.yml);
 * never set it outside dev. Stores nothing; both callbacks only log.
 */
import type { ConsentableService } from './services';

export const isDemoEnabled = (): boolean => import.meta.env.VITE_CONSENT_DEMO === 'true';

export const DEMO_SERVICE: ConsentableService = {
  id: 'demo',
  category: 'analytics',
  // High bit so it can never collide with a production entry.
  revisionBit: 1 << 30,
  isEnabledFor: () => true,
  onAccept: () => console.info('[consent] demo service accepted'),
  onReject: () => console.info('[consent] demo service rejected'),
};
